import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import CatalogueTable from './components/CatalogueTable'
import CatalogueForm from './components/CatalogueForm'

// Breadcrumbs
const crmBreadcrumb: PageLink = {title: 'CRM', path: '/', isSeparator: false, isActive: false}
const crmCatalogueBreadcrumb: PageLink = {
  title: 'Catalogue',
  path: '/crm/catalogue',
  isSeparator: false,
  isActive: true,
}

function CataloguePage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Catalogue</PageTitle>
              <CatalogueTable />
            </>
          }
        />

        <Route
          path='/add'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmCatalogueBreadcrumb]}>
                Add Catalogue
              </PageTitle>
              <CatalogueForm />
            </>
          }
        />

        <Route
          path='/edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmCatalogueBreadcrumb]}>
                Edit Catalogue
              </PageTitle>
              <CatalogueForm />
            </>
          }
        />
      </Route>

      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default CataloguePage
